import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';
import { StudentTypeaheadService } from '../student';
import { StudentComment } from './student-comment.model';
import { StudentCommentPopupService } from './student-comment-popup.service';
import { StudentCommentService } from './student-comment.service';
import { School, SchoolService } from '../school';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal , CRUD_ACTIONS } from '../../shared/index';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-student-comment-dialog',
    templateUrl: './student-comment-dialog.component.html'
})
export class StudentCommentDialogComponent extends AbstractDialogComponent implements OnInit {

    studentComment: StudentComment;
    authorities: any[];
    isSaving: boolean;
    search = this.studentTypeaheadService.search;
    resultFormatter = this.studentTypeaheadService.resultFormatter;
    inputFormatter = (student: any) => this.studentTypeaheadService.inputFormatter(student, () => this.studentComment.student['user']);

    constructor(
        public activeModal: NgbActiveModal,
        alertService: AlertService,
        private StudentCommentService: StudentCommentService,
        private studentTypeaheadService: StudentTypeaheadService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.loadSchools();
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.studentComment.id !== undefined) {
            this.StudentCommentService.update(this.studentComment)
            .subscribe((res: StudentComment) =>
                this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.StudentCommentService.create(this.studentComment)
                .subscribe((res: StudentComment) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.CREATE), (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: StudentComment, action: String) {
        this.eventManager.broadcast({ name: 'StudentCommentListModification', content: {
            action: action,
            content: result
        }});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-student-comment-popup',
    template: ''
})
export class StudentCommentPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private studentCommentPopupService: StudentCommentPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.studentCommentPopupService
                    .open(StudentCommentDialogComponent as Component, params['id']);
            } else if (params['studentId']) {
                this.modalRef = this.studentCommentPopupService
                    .open(StudentCommentDialogComponent as Component, undefined, params['studentId']);
            } else {
                this.modalRef = this.studentCommentPopupService
                    .open(StudentCommentDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student-comment/student-comment-dialog.component.ts